import { initialState, VehiclesState, vehiclesAdapter } from './vehicles.interfaces';
import * as fromVehicles from './vehicles.actions';

export function reducer(state = initialState, action: fromVehicles.VehiclesAction): VehiclesState {
  switch (action.type) {
    case fromVehicles.GET_VEHICLES_FROM_SERVER_SUCCESS: {
      return {
        ...vehiclesAdapter.addMany(action.payload.vehicles, state)
      };
    }

    default: {
      return state;
    }
  }
}
